import addOperation from '@/store/moneyDashboard/addOperation'
import plannedTransactions from "@/store/moneyDashboard/plannedTransactions";
import recentTransactions from '@/store/moneyDashboard/recentTransactions'
import budgetWidget from '@/store/moneyDashboard/budgetWidget'

export default {
    namespaced:true,
    modules:{
        addOperation,
        plannedTransactions,
        recentTransactions,
        budgetWidget
    }
}